import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'

const app = createApp(App)
app.use(router)
app.mount('#app')

// import VuePapaParse from 'vue-papa-parse'
// const app = createApp(App)
// app.use(VuePapaParse)
// app.provide('$papa', app.config.globalProperties.$papa)

// createApp(App).mount('#app')
// app.mount('#app')



// import VueDatePicker from '@vuepic/vue-datepicker';
// import '@vuepic/vue-datepicker/dist/main.css'

// const app = createApp(App);
// app.component('VueDatePicker', VueDatePicker);
// app.mount('#app')

